/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * Get a generated content tool path to the chosen screen.
 * @param {string} contentToolName The name of the content tool.
 * @param {string} contentToolId The id of the content tool.
 * @export
 * @returns {string} A generated organisation path for the chosen screen.
 */
export const getContentToolPath = (contentToolId?: string): string => {
  if (contentToolId) {
    return `/${contentToolId}`;
  }

  // Used for router
  return `/:contentToolId`;
};
